// QR Kiosk v2 — route map, a 1:1 mirror of usePublicRoutes.tsx under
// KioskV2Layout + the identical auth guard. Two deltas vs v1: (a) layout element
// is KioskV2Layout, (b) `solving` gains `:id` (PG-15; the v1 no-param solving
// route is NOT reproduced). STATIC (non-lazy) imports, exactly like MIDAS v3 + v1.
import React from "react";
import { Navigate, Route } from "react-router-dom";
import KioskV2Layout from "../v2/KioskV2Layout";
import KioskDashboardV2 from "../v2/dashboard/KioskDashboardV2";
import ManualsV2 from "../v2/pages/ManualsV2";
import CompanyV2 from "../v2/pages/CompanyV2";
import SpecSheetV2 from "../v2/pages/SpecSheetV2";
import SettingsV2 from "../v2/pages/SettingsV2";
import ReportsListV2 from "../v2/reports/ReportsListV2";
import ReportDetailV2 from "../v2/reports/ReportDetailV2";
import CreateReportV2 from "../v2/reports/CreateReportV2";
import SolveReportV2 from "../v2/reports/SolveReportV2";
import TasksListV2 from "../v2/tasks/TasksListV2";
import TaskDetailV2 from "../v2/tasks/TaskDetailV2";
import GuestLandingV2 from "../v2/guest/GuestLandingV2";
import KioskEntryGate from "../v2/guest/KioskEntryGate";
import NameplateV2 from "../v2/nameplate/NameplateV2";

const usePublicV2Routes = () => {
  return (
    <React.Fragment>
      {/* KV2-8 guest redeem/landing — ANONYMOUS, OUTSIDE the auth guard: a fresh
          magic-link visitor has no token yet. Reads the #code fragment, redeems, stores
          the guest token, then navigates into the guarded kiosk below. */}
      <Route path="guest" element={<GuestLandingV2 />} />

      {/* KV2-9 Tier 0 digital nameplate — ANONYMOUS by design, OUTSIDE the gate: the
          visitor has no token and must not be bounced to sign-in. The id.machine-id.cc
          resolver 302s here (B7-INF1); the page also works opened directly with a raw code. */}
      <Route path="nameplate/:code" element={<NameplateV2 />} />

      {/* KV2-T1: guard swapped AuthorizedRoute → KioskEntryGate. Authenticated paths
          behave byte-identically; an UNAUTHENTICATED machines/:id hit (the printed QR)
          now renders the GuestEntryV2 chooser in place instead of bouncing to login. */}
      <Route path="" element={<KioskEntryGate />}>
        <Route path="" element={<KioskV2Layout />}>
        <Route path="machines">
          <Route path=":id" element={<KioskDashboardV2 />} />
          <Route path=":id/details" element={<SpecSheetV2 />} />
          <Route path=":id/service-reports/:filter" element={<ReportsListV2 />} />
          <Route path=":id/company" element={<CompanyV2 />} />
          <Route path=":id/settings" element={<SettingsV2 />} />
          <Route path=":id/tasks" element={<TasksListV2 />} />
        </Route>

        <Route path="service-reports">
          <Route path=":id" element={<ReportDetailV2 />} />
          <Route path="create" element={<CreateReportV2 />} />
          <Route path="edit/:id" element={<CreateReportV2 />} />
          <Route path="solving/:id" element={<SolveReportV2 />} />
        </Route>

        <Route path="tasks/:number" element={<TaskDetailV2 />} />

        <Route path="documents/:id" element={<ManualsV2 />} />

          <Route path="" element={<Navigate to="machines" />} />
          <Route path="*" element={<Navigate to="" />} />
        </Route>
      </Route>
    </React.Fragment>
  );
};

export default usePublicV2Routes;
